import { toast } from "sonner";

/** Store links come from frontend env (REACT_APP_APP_STORE_URL / REACT_APP_PLAY_STORE_URL); empty = not live yet. */
export const STORES = [
  { id: "ios", label: "Download on the App Store", short: "App Store", url: process.env.REACT_APP_APP_STORE_URL || "" },
  { id: "android", label: "Get it on Google Play", short: "Google Play", url: process.env.REACT_APP_PLAY_STORE_URL || "" },
];

export const storesLive = () => STORES.some((s) => s.url);

export function openStore(store) {
  if (store.url) {
    window.open(store.url, "_blank", "noopener,noreferrer");
    return;
  }
  toast.info(`LuxeRay app on ${store.short} is launching soon`, {
    description: "Leave your number in the enquiry form for early access.",
  });
  document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" });
}

export const AppleIcon = (props) => (
  <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.84c.62-.75 1.04-1.8 0.92-2.84-.9.04-1.99.6-2.64 1.35-.58.67-.99 1.74-.85 2.76 1 .08 1.95-.52 2.57-1.27z" />
  </svg>
);

export const PlayIcon = (props) => (
  <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12 3.84 21.85C3.34 21.6 3 21.09 3 20.5M16.81 15.12L14.75 13.06 14.75 10.94 16.81 8.88 20.25 10.84C21.25 11.41 21.25 12.59 20.25 13.16L16.81 15.12Z" />
  </svg>
);
